export default __webpack_public_path__ + "static/media/PopupIcons_View_Transaction_White.239fe09d.svg";